import { useAuth } from "@clerk/react";
import { useQuery } from "@tanstack/react-query";
import { authenticatedApi } from "@/lib/api";
import type { SessionQuality } from "../../../shared/session-quality";

/** Whether the RD's live provider has an open Healthie Provider identity. */
export type RdHealthieLink = { status: "linked"; url: string } | { status: "unlinked" };

/** The enriched RD projection returned by `GET /api/rds/:id`. */
export interface RdDetailData {
  id: string;
  slug: string;
  name: string;
  supervisedByUserId: string | null;
  supervisorName: string | null;
  sessionCount: number;
  createdAt: string;
  healthieLink: RdHealthieLink;
  /**
   * The Snapshot's Session quality summary; `null` below 3 counted sessions.
   * Optional so a response from a server older than NO-737 reads as `null`.
   */
  sessionQuality?: SessionQuality | null;
}

/** Shared RD-detail query — the workspace surfaces all key off `["rd", rdId]`. */
export function useRdDetail(rdId: string) {
  const { getToken } = useAuth();

  return useQuery({
    queryKey: ["rd", rdId],
    queryFn: () =>
      authenticatedApi<{ data: RdDetailData }>(getToken, `/api/rds/${rdId}`),
    retry: false,
  });
}
